// extracted by mini-css-extract-plugin
export default {"base":"base-SxQZH","description":"description-rZL7k"};